import { getPracticeName } from './practiceLines';

export const buildDocLegal = (practice, tail) => {
  const practiceName = getPracticeName(practice);

  return [
    `© ${new Date().getFullYear()}${practiceName ? ` ${practiceName}` : ''}`,
    'Powered by Myriad Health',
    tail
  ]
    .filter(Boolean)
    .join(' · ');
};
